import dayjs from "dayjs"
import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"
import { DATE_FORMAT } from "@/constants/formats"
import { formatDate } from "@/utils/date"

interface PayFileGenerateConfirmationDialogProps {
  confirmDisabled?: boolean
  toDate: string
  onClose: () => void
  onConfirm: () => void
}

export const PayFileGenerateConfirmationDialog: FC<PayFileGenerateConfirmationDialogProps> = ({
  confirmDisabled,
  toDate,
  onClose,
  onConfirm,
}) => {
  // AK-6633: The backend stamps a new pay file's fromDate with its own "today" when the mutation
  // runs, so this is a best-effort preview off the browser clock. It assumes both clocks agree on
  // the calendar date and won't reflect a timezone mismatch or a midnight rollover while the dialog
  // sits open.
  const fromDate = dayjs().format(DATE_FORMAT.ISO_18601)

  return (
    <ConfirmationDialog
      title={`Are you sure you want to generate a pay file from ${formatDate(fromDate)} to ${formatDate(toDate)}?`}
      content='This action will automatically pull in transactions from that selected time period.'
      closeLabel='Go Back'
      confirmLabel='Generate Pay File'
      confirmDisabled={confirmDisabled}
      onClose={onClose}
      onConfirm={onConfirm}
      testIdPrefix='pay-file.generate-confirmation-dialog'
    />
  )
}
